export const USER_TYPE_STUDENT_LEGACY = 'S';
export const USER_TYPE_STUDENT = '1';
export const USER_TYPE_TEACHER_LEGACY = 'T';
export const USER_TYPE_TEACHER = '2';
export const USER_TYPE_PARENT = '3';
export const USER_TYPE_ADMIN = '9';
export const USER_VN_STUDENT = '84';
export const USER_GENDER_MALE = '1';
export const USER_GENDER_FEMALE = '2';

export const USER_ACCOUNT_TYPE_DEMO = '1';
export const JUNIOR_COLLEGE_STUDENT = {
  JC1: '11',
  JC2: '12',
} as const;
